import { SearchOutlined } from '@ant-design/icons'
import { CustomSearchInputFilter } from '../../../UI/CustomSearchInputFilter/CustomSearchInputFilter'
import moment from 'moment'

export const workersTableColumnsPrev = () => ([
    {
        title: 'TRABAJADOR',
        dataIndex: 'name',
        key: 'name',
        width: '30%',
        align: 'left',
        render: (text, record) => {
            return <span style={{ textDecoration: record.deleted_at && 'line-through', color: record.deleted_at && '#EB5973' }}>{record.name}</span>
        }
    },
    {
        title: 'HORA DE INGRESO',
        dataIndex: 'accessTimeEntered',
        key: 'accessTimeEntered',
        width: '15%',
        align: 'center',
        render: (text, record) => {
            return <span>{record.accessTimeEntered ? moment(record.accessTimeEntered, 'HH:mm:ss:SSS').format('h:mm a') : '---'}</span>
        }
    },
    {
        title: 'HORA DE SALIDA',
        dataIndex: 'accessTimeLeft',
        key: 'accessTimeLeft',
        width: '15%',
        align: 'center',
        render: (text, record) => {
            return <span>{record.accessTimeLeft ? moment(record.accessTimeLeft, 'HH:mm:ss:SSS').format('h:mm a') : '---'}</span>
        }
    },
    {
        title: 'FECHA DE ALTA',
        dataIndex: 'accessDate',
        key: 'accessDate',
        width: '20%',
        align: 'center',
        render: (text, record) => {
            return <span>{record.accessDate ? moment(record.accessDate).format('DD/MM/YYYY') : '---'}</span>
        }
    },
    {
        title: 'FECHA DE BAJA',
        dataIndex: 'deleted_at',
        key: 'deleted_at',
        width: '20%',
        align: 'center',
        render: (text, record) => {
            return record.deleted_at ? <span style={{ color: '#EB5973' }}>{moment(record.deleted_at).format('DD/MM/YYYY')}</span> : <span>---</span>
        }
    },
])

export const workersTableFilters = ({ currentParams, currentFilters, handleSearch, handleReset }) => ({
    name: () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (<CustomSearchInputFilter dataIndex={'name'} placeholder={'Buscar'} setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters} handleReset={handleReset} handleSearch={handleSearch} />),
        filterIcon: () => <SearchOutlined />,
        filteredValue: currentFilters?.name || "",
        sorter: (a, b) => {

        },
        sortDirections: ["descend", "ascend"],
        sortOrder: currentParams?.sort_by === 'name' ? (currentParams.sort_order === 'asc' ? 'ascend' : 'descend') : null,
    }),
    default: () => ({}),
})